<template>
  <div
    class="w-full h-screen flex flex-col justify-center items-center gap-4 p-4 bg-white"
  >
    <div class="text-2xl font-bold text-neutral-900">Acesso não permitido</div>
    <div class="text-sm text-neutral-500">
      Parece que você não possui a permissão necessária para visualizar este
      conteúdo
    </div>
    <Button @click="$router.push('/')">Voltar para o início</Button>
  </div>
</template>
<script>
export default {
  name: 'NoAccess',
  components: {
    Button: () => import('@/modules/designSystem/components/Button')
  }
}
</script>
